import React, { useState, useRef, useEffect } from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import styles from './styles.module.scss';

interface IProps {
  content: string | JSX.Element;
  children: string | JSX.Element;
  width: number;
}

const TextOverflowTooltip = ({ content, width, children }: IProps) => {
  const [overflowActive, setOverflowActive] = useState(false);
  const parentRef = useRef<HTMLDivElement>(null);

  const isEllipsisActive = (elem: HTMLDivElement | null) => (elem ? (elem.offsetWidth < elem.scrollWidth) : false);

  useEffect(() => {
    setOverflowActive(isEllipsisActive(parentRef.current));
  }, [children]);

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id="tooltip" bsPrefix={overflowActive ? styles.tooltip : styles.hidden}>{content}</Tooltip>}
    >
      <div style={{ width }} className={styles.parent} ref={parentRef}>
        {children}
      </div>
    </OverlayTrigger>
  );
};

export default TextOverflowTooltip;
